export const ADMIN_NOTE = "ADMIN";

export function getAddressCountryDetails(addressComponents) {
  const countryComponent = addressComponents.filter((component) =>
    component.types.includes("country")
  )[0];

  return {
    countryCode: countryComponent.short_name,
    country: countryComponent.long_name,
  };
}

export function getAreaLevelOne(addressComponents) {
  let areaLevelOneComponent;
  areaLevelOneComponent = addressComponents.filter((component) =>
    component.types.includes("administrative_area_level_1")
  )[0];

  if (typeof areaLevelOneComponent === "undefined") {
    return {
      shortName: "",
      name: ADMIN_NOTE,
    };
  }

  return {
    shortName: areaLevelOneComponent.short_name,
    name: areaLevelOneComponent.long_name,
  };
}

export function getAddressLocality(addressComponents) {
  let localityComponent;
  localityComponent = addressComponents.filter((component) =>
    component.types.includes("locality")
  )[0];

  if (typeof localityComponent === "undefined") {
    return "";
  }

  return localityComponent.long_name;
}
